import { ValidationIssue } from 'api'
import { uniq } from 'lodash'
import { Severity } from 'model'

export const getUniqueWarningMessagesFromValidationIssues = (validationIssues: ValidationIssue[]) => {
  const warningMessages = validationIssues
    .filter(validationIssue => validationIssue.severity === Severity.WARN)
    .map(validationIssue => validationIssue.errorMessage)

  return uniq(warningMessages)
}

export enum CollateralDialogFields {
  //CollateralMainDetailsPanel Fields
  COLLATERAL_IDENTIFIER_TYPE = 'collateralIdentifierType',
  NAME = 'name',
  COLLATERAL_STATUS = 'status',
  ISIN = 'isin',
  FISIN = 'fisin',
  CFI = 'cfi',
  CUSIP = 'cusip',
  CURRENCY = 'currency',
  COUNTRY_CODE = 'countryCode',
  PRODUCT_SECTOR = 'productSectorId',
  PRODUCT = 'product',
  TRADING_TYPE = 'tradingType',
  CLEAN_PRICE = 'cleanPrice',
  MINIMUM_TICKET_SIZE = 'minimumTicketSize',
  TICKET_INCREMENT = 'ticketIncrement',
  ISSUER = 'issuer',
  ISSUER_LEI = 'issuerLei',
  ISSUE_DATE = 'issueDate',
  COUPON_ACCRUED_INTEREST_DATE = 'couponAccruedInterestDate',
  COUPON_FIRST_DATE = 'couponFirstDate',
  COUPON_MATURITY_DATE = 'couponMaturityDate',
  FIRST_TRADE_INSTANT = 'firstTradeInstant',
  COUPON_TYPE = 'couponType',
  BASIS_CONVENTION = 'basisConvention',
  COUPON = 'coupon',
  COUPON_FREQUENCY = 'couponFrequency',
  TOTAL_ISSUED_NOMINAL_AMOUNT = 'totalIssuedNominalAmount',
  COLLATERAL_TYPE = 'collateralType',
  INDEX_ID = 'indexId',
  INDEX_SPREAD = 'indexSpread',
  INDEX_LAG = 'indexLag',
  BASE_INDEX_VALUE = 'baseIndexValue',
  PROSPECTUS = 'prospectus',
  SENIORITY = 'seniority',
  RIC = 'ric',
  LAST_UPDATED_AT = 'lastUpdatedAtByUserOrSystem',
  LAST_UPDATED_BY = 'lastUpdatedByUser',
  ASSET_TYPE = 'assetType',
  RECOGNISED_EXCHANGE = 'onRecognisedExchange',
  IN_ESMA_FIRDS = 'inEsmaFirds',
  EEA_VENUE_ELIGIBLE = 'eeaVenueEligible',
  UK_VENUE_ELIGIBLE = 'ukVenueEligible',
  RULE_144A_INDICATOR = 'rule144aIndicator',
  ISSUE_ORG_ID = 'issuerOrgId',
  COMPLIANCE_OVERRIDE = 'complianceOverride',
  ISSUE = 'issue',
  REFINITIV_ASSET_TYPE = 'refinitivAssetType',
  REFINITIV_BASE_INDEX = 'refinitivBaseIndex',
  ASSET_SUB_TYPE = 'assetSubType',
  DEBT_TYPE = 'debtType',

  //CollateralAdditionalDetailsPanel Fields
  ASSET_STATUS = 'assetStatus',
  ASSET_STATUS_EFFECTIVE_DATE = 'assetStatusEffectiveDate',
  BOND_TYPE = 'bondType',
  CALLABLE_FLAG = 'callableFlag',
  COUNTRY_OF_INCORPORATION = 'countryOfIncorporation',
  COUNTRY_OF_ISSUANCE = 'countryOfIssuance',
  COUNTRY_OF_RISK_ALL = 'countryOfRiskAll',
  COUNTRY_OF_RISK_PRIMARY = 'countryOfRiskPrimary',
  COUNTRY_OF_RISK_ULTIMATE_PARENT_ALL = 'countryOfRiskUltimateParentAll',
  COUNTRY_OF_RISK_ULTIMATE_PARENT_PRIMARY = 'countryOfRiskUltimateParentPrimary',
  COUPON_RATE_EFFECTIVE_DATE = 'couponRateEffectiveDate',
  DENOMINATION_INCREMENT = 'denominationIncrement',
  DOMICILE = 'domicile',
  ECB_INDICATOR = 'ecbIndicator',
  EX_DIVIDEND_CALENDAR = 'exDividendCalendar',
  EX_DIVIDEND_RULE = 'exDividendRule',
  EX_DIVIDEND_VALUE = 'exDividendValue',
  FACTOR = 'factor',
  FACTOR_DATE = 'factorDate',
  MBS_PRICE_DATE = 'mbsPriceDate',
  FITCH_RATING = 'fitchRating',
  FLOATING_INDEX_TYPE = 'floatIndexType',
  FLOAT_MULTIPLIER = 'floatMultiplier',
  FLOAT_OFFSET = 'floatOffset',
  FLOATER_FLAG = 'floaterFlag',
  FLOATING_RATE_FIXING_DATE = 'floatingRateFixingDate',
  ID = 'id',
  INDUSTRY_SECTOR_CODE = 'industrySectorCode',
  INDUSTRY_SUB_SECTOR_CODE = 'industrySubSectorCode',
  IS_SECURED_FLAG = 'isSecuredFlag',
  LOOK_BACK = 'lookBack',
  MIFID_INDEX_IDENTIFIER = 'mifidIndexIdentifier',
  MIFID_INDEX_NAME = 'mifidIndexName',
  MIFID_INDEX_TERM = 'mifidIndexTerm',
  MINIMUM_DENOMINATION = 'minimumDenomination',
  MOODYS_RATING = 'moodysRating',
  MULTI_STEP_FLOAT_FLAG = 'multiStepFloatFlag',
  OFFERING_TYPE = 'offeringType',
  PERPETUAL_SECURITY_FLAG = 'perpetualSecurityFlag',
  PRIVATE_PLACEMENT_FLAG = 'privatePlacementFlag',
  REFINITIV_CLASSIFICATION_SCHEME = 'refinitivClassificationScheme',
  REGULATION_INDICATOR = 'regulationIndicator',
  S_AND_PR_RATING = 'sandPRating',
  SETTLEMENT_DATE_CONVENTION = 'settlementDateConvention',
  SINKABLE_FLAG = 'sinkableFlag',
  TOTAL_AMOUNT_OUTSTANDING = 'totalAmountOutstanding',
  MIC_REPORT_DATE = 'micReportDate',
  SERIES = 'series',

  //Save Button Field
  SAVE = 'save'
}
